import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// CSS
import "./sideBar.css";

// Components
import Button from "./button";
import IconButton from "./IconButton";
import UserCard from "../User Components/UserCard";
import GetSvgIcon from "../../SvgIcons/SvgIcon";

//Functions and Hooks
import useClickOutside from "../../hooks/useClickOff";
import useNarrowMode from "../../hooks/useNarrowModeChecker";
import { useLogin } from "../../Contexts/LoginContext";
import { Logout, CheckIfLoggedIn } from "../../BackendAccess/UserHooks";
import { useTranslation } from "react-i18next";

function SideBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const ref = useRef(null);
  const { loggedIn, refreshLoginStatus, setLoggedIn } = useLogin();
  const isNarrow = useNarrowMode();

  const items = ["Workspace", "Settings", "Data View"];
  const itemLinks = [
    "/workspace/warehouses",
    "/settings/general",
    "/dataView/activity",
  ];
  const itemIcons = ["workspace", "cog", "data"];

  const [isActiveIndex, setIsActive] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setCollapsed(true);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const checkIfUserIsLoggedIn = async () => {
      const [data, error] = await CheckIfLoggedIn();
      setLoggedIn(!error && data);
    };
    checkIfUserIsLoggedIn();
  }, [setLoggedIn]);

  const handleLogoutClick = async () => {
    try {
      const [data, error] = await Logout();
      if (error) {
      } else {
        refreshLoginStatus();
        setCollapsed(true);
        navigate("/login");
      }
    } catch {}
  };

  const handleNavigation = (path) => {
    setCollapsed(true);
    navigate(path);
  };

  const toggleCollapsed = () => {
    setCollapsed((prev) => !prev);
  };

  const createItems = (item, index) => {
    const IconComponent = GetSvgIcon(itemIcons[index]);
    const isActive = location.pathname.startsWith(
      "/" + itemLinks[index].split("/")[1]
    );

    return (
      <li
        key={item}
        className={`item side icon-animate-parent ${isActive ? "active" : ""}`}
        onClick={() => handleNavigation(itemLinks[index])}
      >
        <IconComponent className="ml-2" />
        <span className="link side">{t(item)}</span>
      </li>
    );
  };

  const createBottomItems = (item, index) => {
    const iconIndex = itemIcons.length - 1 - index;
    const isActive = location.pathname.startsWith(
      "/" + itemLinks[iconIndex].split("/")[1]
    );

    return (
      <div key={item} className={`bottom-bar-btn ${isActive ? "active" : ""}`}>
        <IconButton
          icon={itemIcons[iconIndex]}
          onClick={() => handleNavigation(itemLinks[iconIndex])}
        />
        <span className="bottom-bar-btn-text">{t(item)}</span>
      </div>
    );
  };

  if (!loggedIn) return null;

  // Mobile/Narrow sidebar layout
  if (isNarrow) {
    return (
      <div className="sidebar-bottom-container">
        <div className="sidebar-bottom">
          {items.slice().reverse().map(createBottomItems)}
          <div className="bottom-bar-btn">
            <IconButton icon="logout" onClick={handleLogoutClick} />
            <span className="bottom-bar-btn-text">{t("Log Out")}</span>
          </div>
        </div>
      </div>
    );
  }

  // Full sidebar layout
  return (
    <div
      ref={ref}
      className={`sideBarContainer ${collapsed ? "collapsed" : ""}`}
    >
      <div className={`sidecontainer ${collapsed ? "collapsed" : ""}`}>
        <div className="top-container">
          <div className="sidebarProfile">
            <UserCard />
          </div>
          <ul className="items-list">{items.map(createItems)}</ul>
        </div>
        <div className="bottom-container">
          <Button
            onClick={handleLogoutClick}
            btnStyle="btn-negative"
            icon="logout"
            btnBehaviour="btn-fill"
          >
            {t("Log Out")}
          </Button>
        </div>
      </div>
      <div className="collapse-btn-container">
        <div
          className={`collapseBtn ${collapsed ? "collapsed" : ""}`}
          onClick={toggleCollapsed}
        >
          <div className={`collapseIcon ${collapsed ? "collapsed" : ""}`} />
        </div>
      </div>
    </div>
  );
}

export default SideBar;
